import { create } from 'zustand';

import { GLOBAL_FILTERS } from '@/config/filters.config';

/**
 * TDEV-266 Phase 6 — dashboard-filter store (persistence-free).
 *
 * Server-backed persistence runs through `SettingsSync` (see
 * `apps/dashboard/web/src/components/SettingsSync.tsx`). The zustand
 * `persist` middleware is intentionally removed so the only persistence
 * surface is the `admin_settings` row + the TanStack `EffectiveSettings`
 * query, not localStorage.
 *
 * Public surface ({ filters, setFilter, resetFilters }) MUST stay intact —
 * 21 consumer files import this hook (plan.md:1218, Decision #14 LOCK).
 */
function buildGlobalDefaults(): Record<string, string> {
  const defaults: Record<string, string> = {};
  for (const filter of GLOBAL_FILTERS) {
    if (filter.defaultValue) {
      defaults[filter.id] = filter.defaultValue;
    }
  }
  return defaults;
}

const globalDefaults = buildGlobalDefaults();

interface DashboardFilterState {
  filters: Record<string, string>;
  setFilter: (id: string, value: string) => void;
  resetFilters: () => void;
}

export const useDashboardFilterStore = create<DashboardFilterState>()((set) => ({
  filters: { ...globalDefaults },
  setFilter: (id, value) =>
    set((state) => ({
      filters: { ...state.filters, [id]: value },
    })),
  resetFilters: () =>
    set({
      filters: { ...globalDefaults },
    }),
}));
